'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Immutable from 'immutable';
import Rating from './Rating';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIList from 'UIComponents/list/UIList';
import { QualityRatingsByReviewType } from '../../constants/reviews/RatingAxes';
import { PILL_RATING } from '../../constants/reviews/RatingTypes';
import * as ReviewTypes from '../../constants/reviews/ReviewType';
const I18N_BASE = 'ecosystemMarketplaceCore.reviews.qualityDistribution';

const QualityDistribution = ({
  qualityRatings,
  heading,
  labelSize,
  hideIfEmptyValue,
  reviewType,
  showLabelTooltips
}) => {
  const qualityRatingsObj = qualityRatings.toJS();
  const qualityRatingsOrder = QualityRatingsByReviewType[reviewType];

  const renderQualityRow = (type, value) => {
    const rating = value === 'NaN' ? 0 : value;

    const labelText = /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_BASE}.labels.${reviewType}.${type}`
      })
    });

    const renderedLabel = showLabelTooltips ? /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "display-inline",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_BASE}.tooltips.${reviewType}.${type}`
      }),
      tooltipPlacement: "right",
      children: labelText
    }) : labelText;
    return /*#__PURE__*/_jsx(Rating, {
      type: PILL_RATING,
      label: renderedLabel,
      labelSize: labelSize,
      rating: rating
    }, `${type}_${rating}`);
  };

  return /*#__PURE__*/_jsxs(UIList, {
    children: [heading && /*#__PURE__*/_jsx("span", {
      className: "is--heading-7 m-bottom-2",
      children: heading
    }), qualityRatingsOrder.map(axis => {
      const rating = qualityRatingsObj[axis];

      if ((rating == null || rating === 'NaN') && hideIfEmptyValue) {
        return null;
      }

      return renderQualityRow(axis, rating);
    })]
  });
};

QualityDistribution.propTypes = {
  qualityRatings: PropTypes.instanceOf(Immutable.Map),
  heading: PropTypes.node,
  labelSize: PropTypes.string.isRequired,
  hideIfEmptyValue: PropTypes.bool.isRequired,
  reviewType: PropTypes.oneOf(Object.values(ReviewTypes)).isRequired,
  showLabelTooltips: PropTypes.bool.isRequired
};
QualityDistribution.defaultProps = {
  labelSize: 'sm',
  hideIfEmptyValue: true,
  showLabelTooltips: false
};
export default QualityDistribution;